import { render, staticRenderFns } from "./ShareCategoryPartner.vue?vue&type=template&id=6966843d&scoped=true"
import script from "./ShareCategoryPartner.vue?vue&type=script&lang=js"
export * from "./ShareCategoryPartner.vue?vue&type=script&lang=js"
import style0 from "./ShareCategoryPartner.vue?vue&type=style&index=0&id=6966843d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6966843d",
  null
  
)

export default component.exports